import React, { Component } from 'react';
import { connect } from 'react-redux';
import { WithStyles } from 'decorators/withStyles';
import { ISelectedTopic, IComment } from 'interface/forum';
import CommentItem from './CommentItem';
import { sendComment } from 'actionCreators/forum';
import { IUser } from 'interface/user';
import { ICommentInformations } from '../../../interface/forum';
import Button from '@material-ui/core/Button';
import TableComments from './TableComments';
import { getUrlParams } from 'utils';
import { loadTopicInformations } from 'actionCreators/forum';
import Icon from 'components/Shared/Icon';
import { WithRouter } from 'decorators/withRouter';
import { TextField } from '@material-ui/core';

interface IState {
  text: string;
  error: any;
}

interface IProps {
  selectedTopic?: ISelectedTopic;
  classes?: any;
  sendComment?: typeof sendComment;
  user: IUser;
  comments: IComment;
  history: any;
  loadTopicInformations: typeof loadTopicInformations;
}

@WithStyles({
  topicTitle: {
    fontWeight: 'bold',
  },

  description: {
    color: '#555a62',
    marginBottom: 20,
  },

  container: {
    minWidth: 860,
    maxWidth: 860,
    height: '-webkit-fill-available',
    '@media (max-width: 980px)': {
      minWidth: '100%',
      padding: 20,
    },
  },

  textArea: {
    minHeight: 150,
    padding: 15,
    borderRadius: 5,
  },

  comment: {
    fontSize: 18,
    color: '#555a62',
    fontWeight: 'bold',
  },
  textBold: {
    margin: '30px 0 5px 0',
    color: '#555a62',
    fontSize: 18,
    fontWeight: 'bold',
  },

  btnSend: {
    backgroundColor: '#0291db',
    padding: '5px 18px',
    margin: '5px 0 10px 0',
    color: '#fff',
    float: 'right',
    '&:hover': {
      backgroundColor: '#1fadf7',
    },
    '&:focus': {
      backgroundColor: '#0291db',
    },
  },
  containerTextArea: {
    marginBottom: 130,
  },
  refresh: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  err: {
    color: '#ff0000',
    marginTop: 5,
  },
  refreshIcon: {
    '& svg': {
      width: 40,
      height: 25,
    },
  },
  noComments: {
    height: 300,
    display: 'flex',
    fontSize: 20,
    justifyContent: 'center',
    alignItems: 'center',
    fontStyle: 'italic',
    color: '#555a62',
  },
  textToSend: {
    display: 'none',
  },
  input: {
    border: 'solid 1px',
    borderRadius: '4px',
    padding: '8px',
  },
})
@WithRouter()
class LessonTopics extends Component<IProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = { text: '', error: { hasError: false, msg: '' } };
  }

  changeText = (event: any) => {
    this.setState({ text: event.target.value });
  };

  sendComment = () => {
    const { selectedTopic } = this.props;
    const { text } = this.state;

    if (text.trim().length < 3) {
      this.setState({ error: { hasErr: true, text: 'O texto é pequeno demais' } });
      return;
    }
    if (text.trim().length > 2000) {
      this.setState({ error: { hasErr: true, text: 'Esse texto é grande demais' } });
      return;
    }
    this.setState({ error: { hasErr: false, text: '' } });

    const commentary: Partial<ICommentInformations> = { thread_id: selectedTopic.id, text };
    this.props.sendComment(commentary);

    this.setState({ text: '' });
  };

  refresh = () => {
    let params = getUrlParams();
    const pathname = this.props.history.location.pathname;
    params = { ...params, id: pathname.split('/')[pathname.split('/').length - 1] };
    this.props.loadTopicInformations(params);
  };

  render() {
    const { classes, selectedTopic, user, comments } = this.props;
    const { text, error } = this.state;

    if (!selectedTopic || !comments) return null;
    return (
      <div className={classes.container}>
        <div className={classes.description}>
          <div className={classes.refresh}>
            <h4 className={classes.topicTitle}>{selectedTopic.title}</h4>
            <Button className={classes.refreshIcon} onClick={this.refresh}>
              <Icon name='refresh' /> Recarregar
            </Button>
          </div>

          <CommentItem comment={selectedTopic} user={user} isTitle />
        </div>

        <div className={classes.comment}>Comentários</div>
        {comments.data.length < 1 ? (
          <div className={classes.noComments}>Esse tópico ainda não possui comentários</div>
        ) : null}
        <TableComments comments={comments} isTitle={false} />

        <div className={classes.containerTextArea}>
          <div className={classes.textBold}>Deixe Seu Comentário</div>
          <TextField
            aria-label='Campo para escrita de um comentário para o tópico do forum'
            fullWidth
            InputProps={{ disableUnderline: true }}
            type='text'
            value={text}
            onChange={this.changeText}
            name='comment'
            className={classes.input}
            placeholder='Adicionar comentário...'
            multiline={true}
            id='forum-form-edit'
          />
          {error.hasErr ? <div className={classes.err}>{error.text}</div> : ''}
          <Button className={classes.btnSend} onClick={this.sendComment} variant={'text'}>
            Enviar
          </Button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: any, ownProps: any) => {
  return {
    ...ownProps,
    selectedTopic: state.forum.selectedTopic,
    user: state.user,
    comments: state.forum.comments,
  };
};

export default connect(mapStateToProps, { sendComment, loadTopicInformations })(LessonTopics);
